<template>
  <form v-promise-btn="{ action: 'submit' }" @submit.prevent="submit">
    <card-item>
      <template>
        <div class="d-flex justify-content-center align-items-center">
          <h4 class="card-title">Añadir cliente</h4>
        </div>
      </template>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="nombre">Nombre</label>
            <input
              id="nombre"
              v-model="nombre"
              :class="`form-control form-control-sm text-center bg-white${
                !isNombreOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="apellido">Apellido</label>
            <input
              id="apellido"
              v-model="apellido"
              :class="`form-control form-control-sm text-center bg-white${
                !isApellidoOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="nombreWeb">Nombre Web</label>
            <input
              id="nombreWeb"
              v-model="nombreWeb"
              :class="`form-control form-control-sm text-center bg-white${
                !isNombreWebOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
            <small class="form-text text-muted"
              >Con este nombre aparecerá en el sistema.</small
            >
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="telCelular">Teléfono celular</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span id="prefijo" class="input-group-text">+54</span>
              </div>
              <input
                id="telCelular"
                v-model="telCelular"
                :class="`form-control form-control-sm text-center bg-white${
                  !isTelCelularOk && isDirty ? ' is-invalid' : ''
                }`"
                aria-describedby="prefijo"
                style="cursor: text"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="emailFacturacion"
              >Email facturación</label
            >
            <input
              id="emailFacturacion"
              v-model="emailFacturacion"
              class="form-control form-control-sm text-center bg-white"
              style="cursor: text"
              type="text"
            />
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="emailGerencia">Email Gerencia</label>
            <input
              id="emailGerencia"
              v-model="emailGerencia"
              :class="`form-control form-control-sm text-center bg-white${
                !isEmailGerenciaOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="usuario">Usuario</label>
            <input
              id="usuario"
              v-model="usuario"
              :class="`form-control form-control-sm text-center bg-white${
                !isUsuarioOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="text"
            />
          </div>
          <div class="col-12 col-md-6 form-group form-group-sm">
            <label class="label" for="password">Contraseña</label>
            <input
              id="password"
              v-model="password"
              :class="`form-control form-control-sm text-center bg-white${
                !isPasswordOk && isDirty ? ' is-invalid' : ''
              }`"
              style="cursor: text"
              type="password"
            />
          </div>
        </div>

        <CobranzasForm />

        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-secondary"
                type="button"
                @click="cancelarModal"
              >
                Cancelar
              </button>
              <button class="btn btn-primary" type="submit">Aceptar</button>
            </div>
          </div>
        </div>
      </div>
    </card-item>
  </form>
</template>

<script>
import CobranzasForm from "../../pages/Clientes/CrearCliente/CobranzasForm.vue";
import Bindings from "@/pages/Clientes/CrearCliente/Bindings";

export default {
  name: "CrearCliente",
  mixins: [Bindings],
  components: {
    CobranzasForm,
  },
  mounted() {
    this.resetForm();
  },
  data() {
    return {
      isDirty: false,
    };
  },
  methods: {
    async submit() {
      this.isDirty = true;

      if (this.isDataOk) {
        const resp = await this.$store.dispatch("clientes/NuevoCliente/submit");
        if (resp.ok) {
          this.$router.push("/admin/clientes/");
        } else {
          this.$msgBoxOk(resp.message);
        }
      }
    },
    cancelarModal() {
      this.$router.push("/admin/clientes");
    },
    resetForm() {
      this.$store.commit("clientes/NuevoCliente/resetForm");
      this.isDirty = false;
    },
  },
  computed: {
    isDataOk() {
      return (
        this.isNombreOk &&
        this.isApellidoOk &&
        this.isNombreWebOk &&
        this.isEmailGerenciaOk &&
        this.isUsuarioOk &&
        this.isCobranzasOk &&
        this.isPasswordOk &&
        this.isTarjetaDataOk &&
        this.isRapipagoDataOk // Nueva propiedad
      );
    },
    isTarjetaDataOk() {
      const idCobranza =
        this.$store.state.clientes.NuevoCliente.idCobranzaLugarDePago;
      if (
        idCobranza &&
        (idCobranza.id_ubicacion_dinero === 29 ||
          idCobranza.id_ubicacion_dinero === 48)
      ) {
        return this.$store.state.clientes.NuevoCliente.codigoRapipago == null;
      }
      return true; // Si no es tarjeta, consideramos que está OK
    },
    isRapipagoDataOk() {
      const idCobranza =
        this.$store.state.clientes.NuevoCliente.idCobranzaLugarDePago;
      if (idCobranza && idCobranza.id_ubicacion_dinero === 33) {
        return (
          this.$store.state.clientes.NuevoCliente.nroTarjeta == null &&
          this.$store.state.clientes.NuevoCliente.tipoTarjeta == null
        );
      }
      return true; // Si no es Rapipago, consideramos que está OK
    },
    isNombreOk() {
      return this.nombre !== "";
    },
    isApellidoOk() {
      return this.apellido !== "";
    },
    isNombreWebOk() {
      return this.nombreWeb !== "";
    },
    isTelCelularOk() {
      return this.telCelular !== "";
    },
    isEmailGerenciaOk() {
      return this.emailGerencia !== "";
    },
    isUsuarioOk() {
      return this.usuario !== "";
    },
    isPasswordOk() {
      return this.password !== "";
    },
    isCobranzasOk() {
      return this.cobranzas !== "";
    },
  },
};
</script>

<style scoped></style>
